import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { ModalListAcoesGridComponent } from '../modal-list-acoes-grid/modal-list-acoes-grid.component';

@Component({
  selector: 'grid-list',
  templateUrl: './grid-list.component.html',
  styleUrls: ['./grid-list.component.scss'],
})
export class GridListComponent {

  @Input()
  public listCabecalho: any[] = [];
  @Input()
  public listConteudo: any[] = [];
  @Input()
  public configListCard: any[] = [];

  @Input()
  public tipoGrid = 'pagina';

  @Input()
  public labelBtnAdicionar = 'Adicionar';
  @Input()
  public labelMensagemEstadoVazio = '';

  @Input()
  public imgSemRegistro = '/assets/imgs/img-sem-registro.png';

  @Input()
  public habilitarAcoes = false;
  @Input()
  public habilitarBtnEditar = false;
  @Input()
  public habilitarBtnExcluir = false;
  @Input()
  public habilitarBtnExportar = false;
  @Input()
  public habilitarBtnVisualizar = false;
  @Input()
  public habilitarBtnPainel = false;
  @Input()
  public habilitarBtnAdicionar = false;
  @Input()
  public habilitarPaginacao = true;

  @Output() onEditar = new EventEmitter();
  @Output() onExcluir = new EventEmitter();
  @Output() onExportar = new EventEmitter();
  @Output() onVisualizar = new EventEmitter();
  @Output() onPainel = new EventEmitter();
  @Output() onAdicionar = new EventEmitter();
  @Output() onProximaPagina = new EventEmitter();
  @Output() onPaginaAnterior = new EventEmitter();
  @Output() onOrdenar = new EventEmitter();

  private listAcoes: any[] = [];
  private mobile = false;

  constructor(
    private popoverController: PopoverController,
    private platform: Platform,
  ) {

  }

  async atualizarTipoDispositivo() {
    await this.platform.ready().then((readySource) => {
      // console.log('Width: ' + this.platform.width());
      if (this.platform.width() <= 580) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    });
  }

  async montarListaAcoes() {
    this.listAcoes = [];

    if (this.habilitarBtnVisualizar) {
      this.listAcoes.push({
        nome: 'Visualizar',
        icoNativo: true,
        ico: 'eye'
      });
    }

    if (this.habilitarBtnPainel) {
      this.listAcoes.push({
        nome: 'Painel',
        icoNativo: true,
        ico: 'analytics'
      });
    }

    if (this.habilitarBtnEditar) {
      this.listAcoes.push({
        nome: 'Editar',
        ico: '/assets/custom-icons/editar.svg'
      });
    }

    if (this.habilitarBtnExcluir) {
      this.listAcoes.push({
        nome: 'Excluir',
        ico: '/assets/custom-icons/excluir.svg'
      });
    }

    if (this.habilitarBtnExportar) {
      this.listAcoes.push({
        nome: 'Exportar',
        ico: '/assets/custom-icons/exportar.svg'
      });
    }

  }

  onClickGrafico(event) {
    this.onVisualizar.emit(event);
  }

  editar(item): void {
    this.onEditar.emit(item);
  }

  excluir(item): void {
    this.onExcluir.emit(item);
  }
  exportar(item): void {
    this.onExportar.emit(item);
  }
  visualizar(item): void {
    this.onVisualizar.emit(item);
  }
  painel(item): void {
    this.onPainel.emit(item);
  }
  adicionar(): void {
    this.onAdicionar.emit();
  }
  ordenar(campo): void {
    this.onOrdenar.emit(campo);
  }
  proximaPagina(): void {
    this.onProximaPagina.emit();
  }
  paginaAnterior(): void {
    this.onPaginaAnterior.emit();
  }

  async modalAcoesCard(obj: any, ev: any) {
    await this.montarListaAcoes();
    const popover = await this.popoverController.create({
      component: ModalListAcoesGridComponent,
      event: ev,
      translucent: true,
      componentProps: {
        acoes: this.listAcoes
      }
    });
    await popover.present();

    const { data } = await popover.onWillDismiss();
    // console.log(data);
    if (data) {
      await this.selecionarAcao(obj, data);
    }
  }

  async selecionarAcao(obj, data) {
    switch (data) {
      case 'Editar':
        this.editar(obj);
        break;
      case 'Excluir':
        this.excluir(obj);
        break;
      case 'Exportar':
        this.exportar(obj);
        break;
      case 'Visualizar':
        this.visualizar(obj);
        break;
      case 'Painel':
        this.painel(obj);
        break;
    }
  }
}
